<span class="input-component">
    <div class="input-group content">
        <input class="form-control" [id]="inputId" [formControl]="control" type="text" [placeholder]="placeholder | translate" mask="0" (keyup)="onKeyUpFunction($event)" (paste)="onPasteFunction($event)" />
    </div>
</span>
